import React from 'react';
import { Icon } from '@iconify/react';
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  Stack,
  Tooltip,
  Container,
  Avatar,
  MenuItem,
  Button,
  Divider,
  Menu
} from '@mui/material';

import '../../assets/css/notification-popup.css'

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';


const NotificationDropdown = ({ onSeeAll = () => { } }) => {

  const notifications = [
    {
      id: 1,
      message: "You haven’t submitted your timesheet for this week. It’s due by 5 PM.",
      timestamp: "Today at 9:42 AM",
      buttons: false,
    },
    {
      id: 2,
      message: "Your timesheet for April 1–7 has been submitted successfully.",
      timestamp: "Today at 9:42 AM",
      buttons: ["View Timesheet", "Undo"],
    },
    {
      id: 3,
      message: "You’ve been added to the project “Marketing Launch Q2”. Start tracking your time to get going.",
      timestamp: "Last Wednesday at 9:42 AM",
      buttons: ["View Project", "Later"],
    },
    {
      id: 4,
      message: "[Member Name] has joined your organization. Assign them to a project to get started.",
      timestamp: "Last Wednesday at 9:42 AM",
      avatar: true,
    },
    {
      id: 5,
      message: "Your timesheet for March 25–31 is now locked and cannot be edited.",
      timestamp: "Last Wednesday at 9:42 AM",
      buttons: ["View Summary"],
    },
    {
      id: 6,
      message: "You’ve been made an Admin for your organization. You now have access to manage members, projects, and reports.",
      timestamp: "Last Wednesday at 9:42 AM",
    },
  ];


  return (
    <div className="dropdown">
      <button
        className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
        type="button"
        data-bs-toggle="dropdown"
      >
        <Icon icon="iconoir:bell" className="text-primary-light text-xl" />
      </button>

      <div className="dropdown-menu to-top dropdown-menu-lg p-0">
        <div className="p-16">
          <div className='d-flex align-items-center justify-content-between gap-2'>
            <Typography fontWeight={500}>Notifications (2)</Typography>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}>
              <Typography color="#000" fontWeight={400} fontSize="14px">Mark all as read</Typography>
              <CheckCircleOutlineIcon fontSize="small" sx={{ color: "#000", }} />
            </div>
          </div>
        </div>

        <div className="overflow-y-auto scroll-sm pe-4 responsive-scroll">
          {notifications.map((item) => (
            <Box className="listShowSec" key={item.id} px={2} py={1.5} sx={{ borderBottom: '1px solid #eee', borderTop: '1px solid #eee' }}>
              <Box display="flex" alignItems="flex-start" gap={1}>
                {item.avatar && (
                  <Avatar
                    src="https://via.placeholder.com/32"
                    alt="Member"
                    style={{ width: 32, height: 32 }}
                  />
                )}
                <Box>
                  <Typography variant="body2">{item.message}</Typography>
                  {item.buttons && (
                    <Box display="flex" gap={1} mt={1}>
                      {item.buttons.map((btnText, i) => (
                        <Button key={i} size="small" variant={i === 0 ? 'contained' : 'outlined'} style={{ fontSize: 12, boxShadow: 'unset' }}>
                          {btnText}
                        </Button>
                      ))}
                    </Box>
                  )}
                  <Typography variant="caption" color="text.secondary" style={{ color: '#A5ACB8', fontWeight: ' 400' }}>{item.timestamp}</Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </div>
        <div className="text-center py-12 px-16">
          <Box textAlign="center" class="notificationBottomBtn">
            <Button variant="text" style={{ fontSize: '14px', color: '#0076FE', textTransform: 'capitalize' }}>
              See all notifications
            </Button>
          </Box>
        </div>

      </div>
    </div>
  );
};

export default NotificationDropdown;
